import { format } from './formatter'

export default { format }
